module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Gym_RGB_lr.9c1d80f5.jpg";